// axiosInstance.js
import axios from "axios";
const axiosInstanceSpotfinder = axios.create({
  baseURL: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
});

// Add a request interceptor
axiosInstanceSpotfinder.interceptors.request.use(
  (config: any) => {
    console.log("request", config);
    // You can modify the request config here, e.g., add authentication headers
    // config.headers.Authorization = `Bearer ${getToken()}`;
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstanceSpotfinder.interceptors.response.use(
  (response: any) => {


    // You can modify the response data here, e.g., handling pagination
    return response.data;
  },
  (error: any) => {
    console.log("error", error);
    httpErrorHandler(error)



    return Promise.reject(error);
  }
);

const httpErrorHandler = (error: any) => {
  if (error === null) throw new Error('Unrecoverable error!! Error is null!')
  if (axios.isAxiosError(error) && error?.request?.responseURL.indexOf(process.env.REACT_APP_SPOT_FINDER_BASE_URL) !== -1) {
    //here we have a type guard check, error inside this if will be treated as AxiosError
    const response = error?.response
    const request = error?.request
    const config = error?.config //here we have access the config used to make the api call (we can make a retry using this conf)



    if (response) {
      const statusCode = response?.status;
      const serviceErrorCode = response?.data?.serviceErrors?.[0]?.errorCode;
      if (statusCode === 401 && serviceErrorCode === 'INVALID_CREDENTIALS') {
      }
      if (statusCode === 401 && serviceErrorCode !== 'INVALID_CREDENTIALS') {
        if (typeof window !== 'undefined') {
          window.location.href = `${process.env.REACT_APP_SESSION_EXPIRE_URL}`;
        }

      }
    }
  }
  //Something happened in setting up the request and triggered an Error
  console.log(error.message)
}

export default axiosInstanceSpotfinder;
